<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Enviar comentarios</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="mensajeSoporteForm">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" fxFlex>
                    <mat-button-toggle fxFlex (click)="marcarMensajeComoSugerencia()" [ngClass]="{'green-600': !esUnMensajeDeError}">
                        <mat-icon aria-hidden="false" aria-label="Sugerencia">sentiment_satisfied_alt</mat-icon> Sugerencia
                    </mat-button-toggle>
                    <mat-button-toggle fxFlex (click)="marcarMensajeComoError()" [ngClass]="{'red-500': esUnMensajeDeError}">
                            <mat-icon aria-hidden="false" aria-label="Sugerencia">sentiment_dissatisfied</mat-icon> Reportar problema
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start" class="mt-12">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Asunto</mat-label>
                    <mat-icon matSuffix>edit</mat-icon>
                    <input name="asunto" formControlName="asunto" matInput>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Mensaje</mat-label>
                    <mat-icon matSuffix>edit</mat-icon>
                    <textarea name="mensaje" formControlName="mensaje" matInput></textarea>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="center start">
                <img class="imagen-soporte" src="{{data.captura}}">
            </div>

        </form>

    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button mat-button class="save-button"
            (click)="enviarMensajeSoporte()" 
            aria-label="OK"
            [disabled]="mensajeSoporteForm.invalid">
            Enviar
        </button>

    </div>
</div>